<template>
    <tr class="lms__superadmin_customer_service_show_table_item">
        <template v-if="subscriptionServiceKey && subscriptionServiceKey === 'SSO'">
            <td class="lms__superadmin_customer_service_show_table_item_subscriptionname">
                {{ subscriptionName }}
            </td>
        </template>
        <td class="lms__superadmin_customer_service_show_table_item_subscriptionstart">
            <template v-if="addSubscription">
                <form-date
                    :class="[errors.first(`hidden-add-subscription`) && invalidAddSubscriptionFromDate ? 'lms__superadmin_customer_service_show_table_item_subscriptionstart--error' : '']"
                    :name="'adding-subscription-from-date'"
                    :label="''"
                    :v-validate="`required|date_format:yyyy-MM-dd|${addSubscriptionToDate ? `before:${addSubscriptionToDate}` : ``}`"
                    :data-vv-as="'subscription start'"
                    :v-validate-custom-error="errors.first('adding-subscription-from-date-date--hidden') ? errors.first('adding-subscription-from-date-date--hidden').replace('or equal to', '') : ''"
                    v-model="addSubscriptionFromDate"
                />
            </template>
            <template v-else>
                {{ subscriptionStart }}
            </template>
        </td>
        <td class="lms__superadmin_customer_service_show_table_item_subcriptionend">
            <template v-if="addSubscription">
                <form-date
                    :class="[
                        errors.first(`hidden-add-subscription`) && invalidAddSubscriptionToDate ? 'lms__superadmin_customer_service_show_table_item_subscriptionend--error' : '',
                        isSubscriptionFromValidatedEmpty ? 'lms__superadmin_customer_service_show_table_item_subcriptionend--customspacing' : ''
                    ]"
                    :name="'adding-subscription-to-date'"
                    :label="''"
                    :v-validate="`${isNotCancelledSubscriptionAhead ? `required:true` : ''}|date_format:yyyy-MM-dd|${addSubscriptionFromDate ? `after:${validationRuleSubscriptionTo}` : ``}`"
                    :data-vv-as="'subscription end'"
                    :v-validate-custom-error="errors.first('adding-subscription-to-date-date--hidden') ? errors.first('adding-subscription-to-date-date--hidden').replace('or equal to', '') : ''"
                    v-model="addSubscriptionToDate"
                />
            </template>
            <template v-else>
                {{ subscriptionEnd }}
            </template>
        </td>
        <template v-if="!addSubscription">
            <td class="lms__superadmin_customer_service_show_table_item_status">
                <component-status :status="subscriptionStatus"/>
            </td>
            <td class="lms__superadmin_customer_service_show_table_item_created">
                {{ subscriptionCreated }}
            </td>
            <td class="lms__superadmin_customer_service_show_table_item_cancelled">
                {{ subscriptionCancelled }}
            </td>
        </template>
        <td class="lms__superadmin_customer_service_show_table_item_actions" :colspan="addSubscription ? '4' : '1'">
            <div class="columns is-inline-flex-mobile is-vcentered">
                <div class="column"></div>
                <template v-if="addSubscription">
                    <div class="column is-inline-flex-mobile is-fixed-top-touch is-narrow">
                        <component-button
                            :theme="'default'"
                            @click="emitStopAdding"
                            :name="'lms-superadmin-customer-service-show-table-item-actions-remove'"
                        >{{ $t('lms.customer.buttons.remove') }}
                        </component-button>
                    </div>
                    <div class="column is-inline-flex-mobile is-fixed-top-touch is-narrow">
                        <component-button
                            :theme="'primary'"
                            @click="emitCreateSubscription"
                            :name="'lms-superadmin-customer-service-show-table-item-actions-save'"
                        >{{ $t('lms.customer.buttons.save') }}
                        </component-button>
                    </div>
                </template>
                <template v-else>
                    <template v-if="subscriptionStatus !== 'cancelled'">
                        <div class="column"></div>
                        <template v-if="!isSubscriptionExpired">
                            <div class="column is-inline-flex-mobile is-fixed-top-touch is-narrow">
                                <component-button
                                    :disabled="isSubscriptionExpired"
                                    :theme="'default'"
                                    @click="emitCancelSubscription"
                                    :name="'lms-superadmin-customer-service-show-table-item-actions-cancel'"
                                >Cancel
                                </component-button>
                            </div>
                        </template>
                        <template v-if="subscriptionServiceKey && subscriptionServiceKey === 'SSO'">
                            <div class="column is-inline-flex-mobile is-fixed-top-touch is-narrow">
                                <component-button
                                    :theme="'default'"
                                    @click="performEditSubscription"
                                    :name="'lms-superadmin-customer-service-show-table-item-actions-edit'"
                                >Edit
                                </component-button>
                            </div>
                        </template>
                    </template>
                </template>
            </div>
            <template v-if="addSubscription">
                <div class="columns is-variable">
                    <div class="column has-text-right">
                        <form-text
                            :hidden="'true'"
                            :name="`hidden-add-subscription`"
                            :label="''"
                            :value="'hidden-add-subscription'"
                            :v-validate.continues="{ required: true, checkDatesConflict: [] }"
                        />
                        <span
                            class="form__error form__text_error"
                            v-if="errors.first(`hidden-add-subscription`)"
                        >{{ errors.first(`hidden-add-subscription`) }}</span>
                    </div>
                </div>
            </template>
            <template v-if="addSubscription && getCreateError">
                <div class="columns is-variable">
                    <div class="column has-text-right">
                        <component-note :danger="true">{{ getCreateError }}</component-note>
                    </div>
                </div>
            </template>
        </td>
    </tr>
</template>

<script>
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormDate from '@/components/default/forms/FormDate'
import FormText from '@/components/default/forms/FormText'
import ComponentNote from '@/components/default/shared/ComponentNote'
import { fromLocalDateTimeToUTCISOCustom, toISODateUTC, toLocaleDateTime } from '@/functions'

export default {
  name: 'lms-superadmin-customer-service-show-table-item',
  components: { ComponentNote, FormText, FormDate, ComponentButton, ComponentStatus },
  data () {
    return {
      invalidAddSubscriptionFromDate: false,
      invalidAddSubscriptionToDate: false,
      invalidAddSubscriptionFromDateValue: '',
      invalidAddSubscriptionToDateValue: ''
    }
  },
  props: {
    addSubscription: {
      type: Boolean,
      default: false
    },
    subscription: {
      type: Object,
      default: () => {
      }
    },
    subscriptionsDates: {
      type: Array,
      default: () => {
      }
    }
  },
  computed: {
    routeCustomerId () {
      return this.$route.params.customerId
    },
    getCreateError () {
      return this.$store.getters.getLmsSuperadminCustomerSubscriptionCustomCreateerror
    },
    addSubscriptionFromDate: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerSubscriptionFromDate
      },
      set (value) {
        const dateValue = new Date(value)
        const nextDayValue = new Date(dateValue.setDate(dateValue.getDate() + 1))
        const nextDayValueISO = toISODateUTC(nextDayValue)

        this.$store.dispatch('lmsSuperadminCustomerSubscriptionSetFromDate', value)
        if (value) {
          this.addSubscriptionToDate = nextDayValueISO
        }
      }
    },
    addSubscriptionToDate: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerSubscriptionToDate
      },
      set (value) {
        this.$store.dispatch('lmsSuperadminCustomerSubscriptionSetToDate', value)
      }
    },
    subscriptionStart () {
      const fromDate = this.subscription ? this.subscription.fromDate : ''
      return fromDate ? toLocaleDateTime(fromLocalDateTimeToUTCISOCustom(fromDate)) : '-'
    },
    subscriptionEnd () {
      const toDate = this.subscription ? this.subscription.toDate : ''
      return toDate ? toLocaleDateTime(fromLocalDateTimeToUTCISOCustom(toDate)) : '-'
    },
    subscriptionName () {
      return this.subscription ? this.subscription.name : ''
    },
    subscriptionStatus () {
      return this.subscription ? this.subscription.status : ''
    },
    subscriptionServiceKey () {
      return this.subscription ? this.subscription.serviceKey : ''
    },
    subscriptionID () {
      return this.subscription ? this.subscription.id : ''
    },
    subscriptionCreated () {
      const createdAt = this.subscription ? this.subscription.createdAt : ''
      return createdAt ? this.toLocaleDateTime(createdAt) : '-'
    },
    subscriptionCancelled () {
      const cancelledAt = this.subscription ? this.subscription.cancelledAt : ''
      return cancelledAt ? this.toLocaleDateTime(cancelledAt) : '-'
    },
    //
    watchContentValidation () {
      return this.addSubscriptionFromDate + this.addSubscriptionToDate
    },
    isSubscriptionExpired () {
      const subscriptionTo = this.subscription ? this.subscription.toDate : ''
      const subscriptionExp = new Date(subscriptionTo)
      const now = new Date()
      return subscriptionTo ? subscriptionExp < now : false
    },
    isNotCancelledSubscriptionAhead () {
      const filteredSubscriptions = this.subscriptionsDates
      const addSubscriptionFromDate = new Date(this.addSubscriptionFromDate)
      for (let index in filteredSubscriptions) {
        const loopSubscriptionFromDate = new Date(filteredSubscriptions[index].fromDate)
        if (addSubscriptionFromDate <= loopSubscriptionFromDate) return true
      }
      return false
    },
    isSubscriptionFromValidatedEmpty () {
      const errItems = this.errors.items
      if (errItems.length) {
        return errItems[0].rule === 'required'
      } else {
        return false
      }
    },
    validationRuleSubscriptionTo () {
      const now = new Date()
      const subscriptionFrom = this.addSubscriptionFromDate
      const dateSubscriptionFrom = subscriptionFrom ? new Date(subscriptionFrom) : false
      if (subscriptionFrom && dateSubscriptionFrom < now) {
        return this.toISODateUTC(now)
      } else {
        return this.toISODateUTC(subscriptionFrom)
      }
    }
  },
  watch: {
    watchContentValidation (newVal, oldVal) {
      if (this.addSubscription) {
        setTimeout(() => {
          this.$validator.validate()
        }, 100)
      }
    }
  },
  methods: {
    performEditSubscription () {
      this.$router.push({ name: 'lms-superadmin-customer-service-sso-edit', params: { customerId: this.routeCustomerId, subscriptionId: this.subscriptionID } })
    },
    emitStopAdding () {
      this.$emit('emit-stop-adding')
      this.$store.dispatch('lmsSuperadminCustomerSubscriptionClear')
    },
    emitCancelSubscription () {
      this.$emit('emit-cancel', this.subscriptionID)
    },
    emitCreateSubscription () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('emit-create')
        }
      })
    }
  },
  created () {
    const self = this

    this.$validator.extend('checkDatesConflict', {
      getMessage () {
        const fromDateValue = self.invalidAddSubscriptionFromDateValue
        const toDateValue = self.invalidAddSubscriptionToDateValue
        let strExtra = ''
        strExtra += fromDateValue || toDateValue ? '(' : ''
        strExtra += self.toLocaleDateTime(fromDateValue) || ''
        strExtra += fromDateValue && toDateValue ? ' - ' : ''
        strExtra += self.toLocaleDateTime(toDateValue) || ''
        strExtra += fromDateValue || toDateValue ? ')' : ''
        return `Subscription dates should not conflict with ones already present. ${strExtra}`
      },
      validate () {
        let subscriptionItems = self.subscriptionsDates
        if (subscriptionItems && subscriptionItems.length) {
          const subscriptionItemStart = new Date(self.addSubscriptionFromDate)
          const subscriptionItemEnd = new Date(self.addSubscriptionToDate)

          for (let index in subscriptionItems) {
            const loopSubscriptionItemStart = new Date(subscriptionItems[index].fromDate)
            const loopSubscriptionItemEnd = new Date(subscriptionItems[index].toDate)

            if (
              (
                subscriptionItemStart >= loopSubscriptionItemStart &&
            subscriptionItemStart <= loopSubscriptionItemEnd
              ) && (
                subscriptionItemEnd >= loopSubscriptionItemStart &&
            subscriptionItemEnd <= loopSubscriptionItemEnd
              )
            ) {
              self.invalidAddSubscriptionFromDate = true
              self.invalidAddSubscriptionToDate = true
              self.invalidAddSubscriptionFromDateValue = loopSubscriptionItemStart
              self.invalidAddSubscriptionToDateValue = loopSubscriptionItemEnd
              return false
            } else if (
              (
                subscriptionItemStart >= loopSubscriptionItemStart &&
            subscriptionItemStart <= loopSubscriptionItemEnd
              )
            ) {
              self.invalidAddSubscriptionFromDate = true
              self.invalidAddSubscriptionToDate = false
              self.invalidAddSubscriptionFromDateValue = loopSubscriptionItemStart
              self.invalidAddSubscriptionToDateValue = ''
              return false
            } else if (
              subscriptionItemEnd >= loopSubscriptionItemStart &&
            subscriptionItemEnd <= loopSubscriptionItemEnd
            ) {
              self.invalidAddSubscriptionFromDate = false
              self.invalidAddSubscriptionToDate = true
              self.invalidAddSubscriptionFromDateValue = ''
              self.invalidAddSubscriptionToDateValue = loopSubscriptionItemEnd
              return false
            } else if (
              subscriptionItemStart <= loopSubscriptionItemStart &&
            subscriptionItemEnd >= loopSubscriptionItemEnd
            ) {
              self.invalidAddSubscriptionFromDate = true
              self.invalidAddSubscriptionToDate = true
              self.invalidAddSubscriptionFromDateValue = loopSubscriptionItemStart
              self.invalidAddSubscriptionToDateValue = loopSubscriptionItemEnd
              return false
            }
          }
        }
        self.invalidAddSubscriptionFromDate = false
        self.invalidAddSubscriptionToDate = false
        self.invalidAddSubscriptionFromDateValue = ''
        self.invalidAddSubscriptionToDateValue = ''
        return true
      }
    })
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  inject: ['$validator']
}
</script>
